module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/forecaster-content-forecasters-dcb95fe71682ea0f9f3cbf851b4df068.png";